<script>
import router from "@/router";
import { layoutComputed } from "@/state/helpers";

import Topbar from "@/components/topbar";
import SideBar from "@/components/side-bar";
import Footer from "@/components/footer";

export default {
  components: { Topbar, SideBar,  Footer },
  data() {
    return {
      isMenuCondensed: true,
      userinfo: []
    };
  },
  created: () => {
    document.body.removeAttribute("data-layout", "horizontal");
    document.body.removeAttribute("data-topbar", "dark");
    document.body.setAttribute("data-sidebar", "dark");
  },
  computed: {
    ...layoutComputed,
  },
  methods: {
    applyDefaultSidebarState() {
      if (window.innerWidth >= 992) {
        document.body.classList.add("vertical-collpsed");
        this.isMenuCondensed = true;
      } else {
        document.body.classList.remove("vertical-collpsed");
        this.isMenuCondensed = false;
      }
    },
    toggleMenu() {
      document.body.classList.toggle("sidebar-enable");

      if (window.screen.width >= 992) {
        document.body.classList.toggle("vertical-collpsed");
      } else {
        document.body.classList.remove("vertical-collpsed");
      }
      this.isMenuCondensed = !this.isMenuCondensed;
    }
  },
  mounted() {
    document.body.classList.remove("auth-body-bg");
    this.applyDefaultSidebarState();
    // 路由切换后自动收起移动端侧边栏，并保持桌面端折叠状态
    // eslint-disable-next-line no-unused-vars
    router.afterEach((routeTo, routeFrom) => {
      document.body.classList.remove("sidebar-enable");
      if (window.innerWidth >= 992 && this.isMenuCondensed) {
        document.body.classList.add("vertical-collpsed");
      }
    });
    if (this.loader === true) {
      document.getElementById("preloader").style.display = "block";
      document.getElementById("status").style.display = "block";

      setTimeout(function () {
        document.getElementById("preloader").style.display = "none";
        document.getElementById("status").style.display = "none";
      }, 2500);
    } else {
      document.getElementById("preloader").style.display = "none";
      document.getElementById("status").style.display = "none";
    }    
  },
};
</script>

<template>
  <div>
    <div id="preloader">
      <div id="status">
        <div class="spinner">
          <i class="ri-loader-line spin-icon"></i>
        </div>
      </div>
    </div>

    <!-- Begin page -->
    <div id="layout-wrapper">
      <Topbar />
      <SideBar
        :is-condensed="isMenuCondensed"
        :type="leftSidebarType"
        :width="layoutWidth"
      />
      <!-- ============================================================== -->
      <!-- Start right Content here -->
      <!-- ============================================================== -->
      <div class="main-content">
        <div class="page-content">
          <div class="container-fluid">
            <div class="page-container">
              <slot />
            </div>
          </div>
        </div>
        <Footer />
      </div>
      
    </div>
  </div>
</template>